<div class="page">
  <div class="page__content">
    <h1 class="header">{{ "step_is_company.title" | translate }}</h1>
    <p>{{ "step_is_company.text" | translate }}</p>
    <form class="option-selector">
      <custom-option [formControl]="isCompanyControl" [value]="true">
        <svg-icon
          option__image
          src="assets/icons/user-circle.svg"
          alt="user"
        ></svg-icon>
        <div option__label>
          {{ "step_is_company.option_company" | translate }}
        </div>
      </custom-option>

      <custom-option
        [ngModel]=""
        [formControl]="isCompanyControl"
        [value]="false"
      >
        <svg-icon
          option__image
          src="assets/icons/user-circle.svg"
          alt="user"
        ></svg-icon>
        <div option__label>
          {{ "step_is_company.option_individual" | translate }}
        </div>
      </custom-option>
    </form>
    <p>
        {{ "privacy_policy.text" | translate}} <a class="ep-link" [href]="'privacy_policy.url' | translate" target="_blank">{{ "privacy_policy.link_text" | translate }}</a>.
    </p>

  </div>
  <div class="page__footer">
    <button
      customButton
      customOnboardingNext
      [disabled]="isCompanyControl.invalid"
      expand="full"
      size="large"
    >
      {{ "step_is_company.button_next" | translate }}
    </button>
  </div>
</div>
